import { FancyInput } from 'components/ui/Inputs';
import React from 'react';
import { setCustomerPurchaseOrderNumberContains } from 'redux/services/twittlebugs/sparingParams';
import { useAppDispatch } from 'redux/store';
import { useDebouncedCallback } from 'use-debounce';

export const CustomerOrderNumberFilter = (): JSX.Element => {
  /* ******************** Hooks ******************** */
  const dispatch = useAppDispatch();

  /* ******************** Functions ******************** */
  const handleChange = useDebouncedCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    dispatch(setCustomerPurchaseOrderNumberContains(value || undefined));
  }, 500);

  return <FancyInput placeholder="Secondary Reference Number" onChange={handleChange} allowClear />;
};
